const STORAGE_KEY = 'lotus:pending_invite_key';

export function stashInviteToken(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
}

export function getPendingInviteToken(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearPendingInviteToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
